module.exports = __webpack_public_path__ + "static/media/fff_logo.dcd33c10.png";